// extracted by mini-css-extract-plugin
export default {"SidebarNavigation":"SidebarNavigation_SidebarNavigation__xEGVj","MenuLinks":"SidebarNavigation_MenuLinks__qYWCE"};